import React, { useState } from 'react';
import {
    useRecordContext,
    useDelete,
    Confirm,
    useNotify,
    useRedirect
} from 'react-admin';

import DeleteIcon from '@mui/icons-material/Delete';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import { deleteButtonCss } from '../shared/Styles/buttonStyles';

export const ConfirmDialogDeleteButtonCustom = ({ titolo, messaggio, servizio, redirectPath }) => {
    const record = useRecordContext();
    const [open, setOpen] = useState(false);
    const notify = useNotify();
    const redirect = useRedirect();

    const [deleteOne, { isLoading }] = useDelete();

    const handleClick = () => setOpen(true);
    const handleDialogClose = () => setOpen(false);
    const handleConfirm = () => {
        if (record && record.id) {
            deleteOne(servizio, { id: record.id, previousData: record }, {
                onSuccess: () => {
                    notify('Record eliminato con successo', 'info');
                    window.location.reload();  // Esegue il refresh della pagina
                },
                onFailure: (error) => {
                    notify(`Errore: ${error.message}`, 'warning');
                }
            });
        }
        setOpen(false);
    };

    if (!record || !record.id) {
        return null;
    }

    return (
        <>
            {isLoading ? (
                <CircularProgress size={24} sx={{ color: '#e85a2c' }} />
            ) : (
                <Button
                    sx={deleteButtonCss}
                    onClick={handleClick}
                    variant="contained"
                    size="small"
                    endIcon={<DeleteIcon />}
                    component="label"
                    color="error"
                >
                    Elimina
                </Button>
            )}
            <Confirm
                isOpen={open}
                loading={isLoading}
                title={titolo || "Elimina record"}
                content={messaggio}
                onConfirm={handleConfirm}
                onClose={handleDialogClose}
                confirm="Si"
                cancel="No"
            />
        </>
    );
};
